import { Box, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface submissionModalProps {
  isOpen: boolean;
  handleClose: () => void;
  isSuccessful: boolean;
}

const outerStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  borderRadius: 2,
  width: { xs: "87vw", sm: "80vw" },
  maxWidth: 600,
  maxHeight: "75vh",
  display: "flex",
  flexDirection: "column",
  overflow: "visible", 
};

const contentStyle = {
  overflowY: "auto",
  flex: "1 1 auto",
  minHeight: 0,
  pr: 0,
  pl: 0,
};


const submissionModal = ({ isOpen, handleClose, isSuccessful }: submissionModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="where-modal-title"
      aria-describedby="where-modal-description"
    >
      <Box sx={outerStyle}>
        <IconButton
          onClick={handleClose}
          aria-label="close"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: "text.secondary",
            backgroundColor: "rgba(255,255,255,0.85)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,1)",
            },
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={contentStyle}>
          {isSuccessful ? (
            <Typography variant="body1">
              Your RSVP has been successfully submitted. Thank you!
            </Typography>
          ) : (
            <Typography variant="body1">
              There was an error submitting your RSVP. If this persists, please contact us personally to confirm your attendance.
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default submissionModal;
